import { merge } from 'lodash-es';

import { ChartInteractionsConfig } from '../types/interactions.js';

const defaultInteractions: ChartInteractionsConfig = {
  pan: { enabled: false },
  zoom: { enabled: false },
  zoomX: { enabled: false },
};

export function getInteractions<T>(
  contextInteractions: ChartInteractionsConfig | undefined,
  slotsChartInteractions: ChartInteractionsConfig,
  propsInteractions: T = <T>{},
) {
  const interactions = merge(
    {},
    defaultInteractions,
    contextInteractions,
    slotsChartInteractions,
    propsInteractions,
  ) as ChartInteractionsConfig;

  return interactions;
}
